// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3DAZA","Success":"Button_Success__emAOQ","Danger":"Button_Danger__UlPU_"};